module.exports = __webpack_public_path__ + "static/media/editIcon.c015ee5d.svg";